import { SET_WEATHER } from '../types.js';

const initialState = {
  "temperature": null,
  "condition": null,
  "error": null
}

export default function reducerState (state = initialState, action) {
  switch(action.type) {
    case SET_WEATHER :
      return { ...state, ...action.payload}
    default:
      return state;
  }
}
